export { default as Component } from "./Form.svelte";
export const modes = ["static"];
